<template>
        <mt-loadmore :bottom-method="getNotifyListHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
            <ul id="notify">
                <li v-for="item in notifyList" :key="item.id" @click="readDetail(item)">
                    <div class="left">
                        <h4><span>{{ item.content }}</span></h4>
                        <label>{{ item.currentTime }}</label>
                    </div>
                    <div class="right">
                        <mt-button size="small" type="primary" plain @click.stop="deleteNotifyHandle(item.id)">删除</mt-button>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#se-icon-arrow-right"></use>
                        </svg>                 
                    </div>
                </li>
            </ul>
        </mt-loadmore>
</template>
<script>
import { wxRequest} from '@/api/agent.js'
export default {
    data(){
        return {
            notifyList: [],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            allLoaded: false
        }
    },
    methods: {
        getNotifyListHandler(){
            this.pageNo += 1;
            var data = {
                pageNo: this.pageNo,
                perPageNum: this.perPageNum,
            }
            wxRequest('agentNotice/list', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.allLoaded = true;
                    }

                    this.notifyList = this.notifyList.concat(res.data.data.resultList)
                    this.$refs.loadmore.onBottomLoaded(); 
                    this.$nextTick(function(){
                        window.scroll(0,0);
                    })                    
                }
            })
        },
        deleteNotifyHandle(id){
            this.$messagebox.confirm('您确定删除吗？').then(action => {
                if(action == 'confirm'){
                    wxRequest('agentNotice/delete', {id}, 'post').then(res => {
                        if(res.data.code == 200){
                            this.$toast({
                                message: '删除成功',
                                position: 'middle',
                                duration: 1500
                            })
                            this.pageNo = 0;
                            this.notifyList = [];
                            this.getNotifyListHandler();
                        }
                    })
                }
            })
        },
        readDetail(item){
            this.$router.push({
                name: 'notifyDetail',
                query: item
            })
        }
    },
    created(){
        this.getNotifyListHandler();
    }
}
</script>
<style lang="less">
ul#notify {
    li {
        display: flex;
        justify-content: space-between;
        padding: 12px 6px;
        border-bottom: 1px solid #e5e5e5;
        .left {
            width: calc(100% - 100px);
            h4 {
                font-size: 16px;
                margin-bottom: 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            label {
                font-size: 12px;
                color: #838383;
            }            
        }
        .right {
            width: 100px;
            flex-shrink: 0;
            text-align: right;
            svg {
                vertical-align: middle;
            }
        }
    }
}


</style>
